var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',_vm._g(_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-list-item',_vm.$attrs,false),_vm.other_listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }